// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2xUu9","image":"styles-module__image___3ixKL","headingText":"styles-module__headingText___3n9_S","subText":"styles-module__subText___3-3Rh"};